import React from "react";
import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <Seo title="Page Not Found" description="This page doesn't exist." path="/404" />
      <Sprout className="w-10 h-10 text-sage mx-auto mb-8" strokeWidth={1.5} />
      <div className="text-xs tracking-wider-2 uppercase text-sage mb-3">404</div>
      <h1 className="font-display text-5xl sm:text-6xl text-darkRoast">
        Nothing planted here.
      </h1>
      <p className="mt-6 text-earth max-w-md mx-auto">
        This page doesn't exist, but we have 30+ seed varieties that do.
      </p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link
          to="/shop"
          className="inline-flex items-center gap-2 bg-darkRoast text-cream rounded-full px-7 py-3.5 text-sm tracking-wider-2 uppercase hover:bg-sage transition-colors"
        >
          Browse seeds
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-2 border border-darkRoast/20 text-darkRoast rounded-full px-7 py-3.5 text-sm tracking-wider-2 uppercase hover:border-sage hover:text-sage transition-colors"
        >
          Go home
        </Link>
      </div>
    </div>
  );
}
